import { useEffect, useRef, useState } from "react";
import { RealLoadingBar } from "../utils/loadingBar";

export function useLoadingGate({ freezeOnceReady = true } = {}) {
    const [ready, setReady] = useState(false);
    const locked = useRef(false);

    useEffect(() => {
        const unsub = RealLoadingBar.subscribe((snap) => {
            if (!snap.visible) {
                if (!locked.current) {
                    locked.current = true;
                    setReady(true);
                }
            } else if (!freezeOnceReady && !locked.current) {
                setReady(false);
            }
        });
        return unsub;
    }, [freezeOnceReady]);

    return ready;
}
